import { render, staticRenderFns } from "./extraSubProducts.vue?vue&type=template&id=5d28758e&scoped=true"
import script from "./extraSubProducts.vue?vue&type=script&lang=js"
export * from "./extraSubProducts.vue?vue&type=script&lang=js"
import style0 from "./extraSubProducts.vue?vue&type=style&index=0&id=5d28758e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d28758e",
  null
  
)

export default component.exports